import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { clearAuthCookies } from '@/lib/cookies';
import { isAllowedRedirect } from '@/lib/redirect';

export default function SignOut() {
    const [searchParams] = useSearchParams();
    const redirectParam = searchParams.get('redirect');

    useEffect(() => {
        clearAuthCookies();
        const signInUrl =
            redirectParam && isAllowedRedirect(redirectParam)
                ? `/sign-in?redirect=${encodeURIComponent(redirectParam)}`
                : '/sign-in';
        window.location.replace(signInUrl);
    }, [redirectParam]);

    return null;
}
